import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 d-flex flex-column justify-content-center" }
const _hoisted_2 = { class: "fw-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("b", null, _toDisplayString(_ctx.formatingDateOrTime(_ctx.today, _ctx.dateFormat)), 1 /* TEXT */),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.formatingDateOrTime(_ctx.today, _ctx.timeFormat)) + " " + _toDisplayString(_ctx.timeZone), 1 /* TEXT */)
  ]))
}